module.exports = __webpack_public_path__ + "img/unlock.f81da103.svg";